import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GalleryResponse } from '../model/gallery-response.model';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  private apiUrl = environment.baseApiUrl + '/galleries';

  constructor(private http: HttpClient) { }

  getAlbums(page: number, limit: number): Observable<GalleryResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())

    return this.http.get<GalleryResponse>(this.apiUrl + '/album', { params });
  }

}
